import { PersonalPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import Personal from 'modules/employees/components/Personal'

const ProfilePersonalRoute = () => {
  const { employee } = useCurrentSession()

  if (!employee) {
    throw new Error('Current employee not found')
  }

  const { data, loading } = useQuery(PersonalPageDocument, {
    variables: {
      employeeId: employee.id,
      usageGroupSlugs: ['general-information', 'identification-number', 'basic-information'],
    },
  })

  const customResourceFieldsData = compact(
    data?.customFields?.resourceFields.filter((resourceField) => !!resourceField?.field) ?? []
  )
  const customValuesData =
    data?.customFields?.resourceFields?.flatMap((rf) => rf.field?.value ?? []) ?? []

  if (loading) {
    return <Loading />
  }

  return (
    <Personal
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default ProfilePersonalRoute
